import { colors } from '@spaceshipapp/cambridge';
import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Step = styled.a`
  color: ${colors.brandPrimary};
`;
